<template lang="pug">
.box
    .box-header.dker
        p.pull-right
            label.md-switch
                input.has-value(
                    :checked="product.use_variant",
                    type="checkbox",
                    :disabled="variants.length > 1",
                    @change="updateProductAttr($event.target.checked, 'use_variant')"
                )
                i.green
                | Use Variant

        h3 Pricing
    
    .box-divider.m-a-0

    //- if no variant
    .table-responsive
        table.table.m-b-0
            tbody
                tr
                    td.p-b-0.text-nowrap(v-show="product.use_variant") Name
                    td.p-b-0.text-nowrap Sku
                    td.p-b-0.text-nowrap Cost
                    td.p-b-0.text-nowrap Selling Price
                    td.p-b-0.text-nowrap(v-if="product.track_stock && isTypeInventory") Barcode

                tr(v-for="(v, index) in variants", :key="`p_${product.id}_v_${v.id}`")
                    td(v-show="product.use_variant")
                        input.form-control.min-100(
                            name="name",
                            type="text",
                            placeholder="Name",
                            :value="v.name",
                            :class="{ 'has-error': errors.has('name', `name_p_${product.id}_${v.id}`) }",
                            :key="`name_p_${product.id}_${v.id}`",
                            :data-vv-scope="`name_p_${product.id}_${v.id}`",
                            v-validate="product.use_variant ? 'required' : ''",
                            @input="updateVariantAttr(index, 'name', $event.target.value)"
                        )
                        span.text-danger(v-if="errors.has('name', `name_p_${product.id}_${v.id}`)")
                            | {{ errors.first('name', `name_p_${product.id}_${v.id}`) }}
                    td
                        input.form-control.min-100(
                            :class="{ 'has-error': hasLaravelError(index, 'sku') }",
                            name="sku",
                            type="text",
                            @input="updateVariantAttr(index, 'sku', $event.target.value)",
                            :value="v.sku",
                            placeholder="Sku"
                        )
                        span.text-danger(v-if="hasLaravelError(index, 'sku')")
                            | {{ laraverErrorMsg(index, 'sku') }}
                    td
                        input.form-control.min-100(
                            name="cost",
                            v-validate="'decimal:2|min_value:0'",
                            type="number",
                            @input="updateVariantAttr(index, 'cost', $event.target.value)",
                            :value="v.cost",
                            placeholder="0.00"
                        )

                    td
                        input.form-control.min-100(
                            name="price",
                            v-validate="'required|decimal:2|min_value:0'",
                            type="number",
                            @input="updateVariantAttr(index, 'price', $event.target.value)",
                            :value="v.price",
                            placeholder="0.00"
                        )

                    td(v-if="product.track_stock && isTypeInventory")
                        input.form-control.min-100(
                            name="barcode",
                            type="text",
                            @input="updateVariantAttr(index, 'barcode', $event.target.value)",
                            :value="v.barcode",
                            placeholder="Optional but must be unique",
                        )
                        span.text-danger(v-if="hasLaravelError(index, 'barcode')")
                            | {{ laraverErrorMsg(index, 'barcode') }}

                    td.p-l-xs.p-r-sm.text-muted(v-show="variants.length > 1")
                        //- prevent default variant from being removed
                        button.md-btn.md-flat.m-b-sm.btn-xs(
                            :disabled="isCompositeComponent(v)",
                            v-if="v.default || variants != 0",
                            @click="deleteVariant(index, v)")
                            i.material-icons delete

    .box-footer.text-right(v-if="product.use_variant")
        button.md-btn.md-flat.text-dark(@click="addVariant")
            i.material-icons add
            | Add Variant
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import productMixin from './product-mixins';

export default {
    inject: ['$validator'],

    mixins: [productMixin],

    computed: {
        ...mapGetters('product', ['product', 'variants', 'isTypeInventory']),
    },

    methods: {
        ...mapActions('product', [
            'setProductAttribute',
            'addVariant',
            'removeVariant',
            'setVariantAttr',
        ]),

        updateProductAttr(value, key) {
            this.setProductAttribute({ key, value });
        },

        updateVariantAttr(index, key, value) {
            this.setVariantAttr({ index, value, key });
        },

        hasLaravelError(vindex, field) {
            const scope = `variants.${vindex}.${field}`;
            return this.errors.all(scope).length > 0;
        },

        laraverErrorMsg(vindex, field) {
            const scope = `variants.${vindex}.${field}`;
            return this.errors.all(scope)[0];
        },

        deleteVariant(index, variant) {
            if (variant.id > 0) {
                swal({
                    text: 'Delete variant from products ?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dc3545',
                    cancelButtonColor: '#fff',
                    cancelButtonClass: 'text-dark',
                    confirmButtonText: 'Yes, delete it!',
                }).then(result => {
                    if (result) {
                        this.removeVariant(index);
                    }
                });
            } else {
                this.removeVariant(index);
                this.clearAllBackEndErrorScope();
            }
        },

        isCompositeComponent(variant) {
            return variant.stock.end_products.length > 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/product/product-variants.vue